import { createContext, useContext } from 'react'
import useUnreadNotificationsCounter from '../../hooks/notification/useUnreadNotificationsCounter'
import useFetchThirdPartyCollectorsDashboardData from '../../hooks/dashboard/useFetchThirdPartyCollectorsDashboardData'
import { DashboardDataThirdPartyCollectors } from '../../utils/types/dashboardTypes'

type NotificationCounterContextType = {
  notificationsCounter: number
  startRefresh: () => void
  stopRefresh: () => void
  dashboardData: DashboardDataThirdPartyCollectors | undefined
  startRefreshJobStatus: () => void
  stopRefreshJobStatus: () => void
}

export const NotificationCounterContext = createContext<
  NotificationCounterContextType | undefined
>(undefined)

export const useNotificationCounterContext = () => {
  const context = useContext(NotificationCounterContext)

  if (context === undefined) {
    throw new Error(
      'useNotificationCounterContext must be used within a NotificationsCounterContextProvider'
    )
  }

  return context
}

type NotificationsCounterContextProviderProps = {
  children: React.ReactNode
}

export const NotificationsCounterContextProvider = ({
  children,
}: NotificationsCounterContextProviderProps) => {
  const { notificationsCounter, startRefresh, stopRefresh } =
    useUnreadNotificationsCounter()

  const {
    dashboardData,
    startRefresh: startRefreshJobStatus,
    stopRefresh: stopRefreshJobStatus,
  } = useFetchThirdPartyCollectorsDashboardData(true)

  return (
    <NotificationCounterContext.Provider
      value={{
        notificationsCounter,
        startRefresh,
        stopRefresh,
        dashboardData,
        startRefreshJobStatus,
        stopRefreshJobStatus,
      }}
    >
      {children}
    </NotificationCounterContext.Provider>
  )
}
